import React from 'react';
import { Box, Link } from '@apia/theme';
import { downloadUrl } from '@apia/util';
import { Icon } from '@apia/icons';
import {
  TAccordionCellRenderer,
  TAccordionCellRendererProps,
} from './AccordionCell';

export type TDocNameCellRendererProps = {
  docName: string;
  docUrl: string;
};

export type TDocNameCellRenderer =
  TAccordionCellRendererProps<TDocNameCellRendererProps>;

const NoMemoAccordionDocNameCellRenderer: TAccordionCellRenderer<TDocNameCellRendererProps> =
  React.forwardRef<HTMLElement, TDocNameCellRenderer>(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
      },
      currentRef,
    ) => (
      <Box ref={currentRef as React.RefObject<HTMLElement>} {...cell}>
        <Box as="strong">{column.label ?? column.name}: </Box>
        <Link
          className="cell__download__document"
          title={rendererProps?.docName}
          href={rendererProps?.docUrl}
          onClick={(ev) => {
            ev.preventDefault();
            if (rendererProps?.docUrl) void downloadUrl(rendererProps?.docUrl);
          }}
        >
          <Icon title="" name="Download" />
          {rendererProps?.docName}
        </Link>
      </Box>
    ),
  );

NoMemoAccordionDocNameCellRenderer.displayName = 'AccordionDocNameCellRenderer';

export const AccordionDocNameCellRenderer = NoMemoAccordionDocNameCellRenderer;
